var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSideArrow(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5241 15.4545C15.0535 15.4487 15.4808 15.0202 15.4852 14.4908L15.5956 1.18001C15.601 0.527479 15.0703 -0.00262479 14.4177 0.00317209C10.6603 0.0365526 4.75255 0.0785907 1.09311 0.111576C0.568939 0.116301 0.146594 0.538099 0.137982 1.06222C0.129045 1.60611 0.570229 2.05033 1.11418 2.04542C3.61183 2.02284 6.56321 2.00233 9.43688 1.97941C10.4814 1.97108 11.0109 3.23419 10.2723 3.97276L0.281859 13.9631C-0.0916995 14.3366 -0.091703 14.9423 0.281852 15.3158C0.655403 15.6894 1.26105 15.6894 1.6346 15.3158L11.6252 5.32535C12.3638 4.58679 13.6262 5.11643 13.6168 6.16087L13.5415 14.4739C13.5366 15.0183 13.9797 15.4606 14.5241 15.4545Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSideArrow);
export default __webpack_public_path__ + "static/media/SideArrow.5a00b41e98b09aedc94e346ae4942e21.svg";
export { ForwardRef as ReactComponent };